"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _discussion = babelHelpers.interopRequireDefault(require("./_discussion"));

var _decorators = require("decorators");

var CommentCard =
/*#__PURE__*/
function (_DiscussionCard) {
  babelHelpers.inherits(CommentCard, _DiscussionCard);

  function CommentCard() {
    babelHelpers.classCallCheck(this, CommentCard);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CommentCard).apply(this, arguments));
  }

  return CommentCard;
}(_discussion.default);

exports.default = CommentCard;